import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@shared/stores/authStore';
import { LoadingScreen } from '@shared/components/LoadingScreen';
import { isBitrix24Context } from '@shared/hooks/useBitrix24';

export function AuthGuard() {
  const { isAuthenticated, isLoading, validateSession } = useAuthStore();
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    // Clean stale context: sc_context=bitrix24 but no BX24 SDK means we're outside iframe
    if (localStorage.getItem('sc_context') === 'bitrix24' && typeof window.BX24 === 'undefined') {
      localStorage.removeItem('sc_context');
    }
    validateSession().finally(() => setValidated(true));
  }, [validateSession]);

  if (isLoading || !validated) {
    return <LoadingScreen message="Validating session..." />;
  }

  if (!isAuthenticated) {
    if (isBitrix24Context()) {
      window.location.href = '/bitrix24/handler.html';
      return <LoadingScreen message="Redirecting to Bitrix24..." />;
    }
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
